import React, { useState } from 'react';
import { Form, Button, Input, Space, Toast } from '@douyinfe/semi-ui';
import request from '../../utils/request';
import styles from './index.module.scss';
import { siteConfig } from '../../config';
import Register from '../Register';

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await request.post('/go/common/login/', {
        account: values.username,
        passwd: values.password,
        code: ''
      });

      if (response.errno === 0 && response.token) {
        // 保存登录状态和用户信息
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('user', JSON.stringify({ username: values.username }));
        localStorage.setItem('token', response.token);
        Toast.success('登录成功');
        setLoading(false);

        // 检查是否有重定向URL
        const redirectUrl = localStorage.getItem('redirectUrl');
        if (redirectUrl) {
          localStorage.removeItem('redirectUrl');
          window.location.href = redirectUrl;
        } else if (onLogin) {
          onLogin();
        }
      } else {
        Toast.error(response.errstr || '登录失败');
        setLoading(false);
      }
    } catch (error) {
      console.error('登录失败:', error);
      Toast.error('网络连接失败，请检查网络');
      setLoading(false);
    }
  };

  if (showRegister) {
    return <Register onLogin={onLogin} />;
  }

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <div className={styles.loginHeader}>
          <img src={siteConfig.site.logo} alt={siteConfig.site.shortName} className={styles.logo} />
          <h2>{siteConfig.site.title}</h2>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Input
            field="username"
            label="用户名"
            placeholder="请输入用户名"
            rules={[{ required: true, message: '请输入用户名' }]}
          />
          <Form.Input
            field="password"
            label="密码"
            type="password"
            placeholder="请输入密码"
            rules={[{ required: true, message: '请输入密码' }]}
          />
          <Space vertical align="start" spacing="loose" style={{ width: '100%' }}>
            <Button
              theme="solid"
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              className={styles.loginButton}
            >
              登录
            </Button>
            {siteConfig.features.register.enabled && (
              <Button
                theme="light"
                type="primary"
                block
                onClick={() => setShowRegister(true)}
              >
                注册新账号
              </Button>
            )}
          </Space>
        </Form>
      </div>
    </div>
  );
};

export default Login;